export enum EAlertState {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  ALL = "ALL",
}
